module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    attrs: {
      "id": "toc_marker-2",
      "title": "Dedication"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To Todd Capen and Jeff Weigum")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Thank you for teaching me the faith in love, passion and humility")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Kelly")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To my parents, Gaylen and Marla Vander Lugt")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For passionately upholding and consistently demonstrating the richness of the Reformed tradition")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Wes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4798650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dedication.vue
// module id = 63
// module chunks = 0